export default __webpack_public_path__ + "static/media/hatchlogo.f171d789.png";